import * as Yup from 'yup';

const requiredText = 'Это обязательное поле';

export const validationSchemaAuth = Yup.object().shape({
  username: Yup.string().required(requiredText),
  password: Yup.string()
    .required(requiredText)
    .min(8, 'Пароль должен содержать не менее 8 символов')
});
